import { Autocomplete, Button, CircularProgress, Divider, Drawer, FormLabel, Grid, TextField, Typography } from "@mui/material";
import React, { FC, useEffect, useState } from "react";
import { useDrawerStore } from "../../../hooks/useDrawerStore";
import { useSearcherStore } from "../../../hooks/useSearcherStore";
import { useSupplierStore } from "../../../hooks/useSupplierStore";
import { ApiStatus } from "../../../types/api/status";
import { CustomSnackbar } from "../../../components/common/CustomSnackbar/CustomSnackbar";
import { useDocumentOfSalesStore } from "../../../hooks/useDocumentOfSalesStore";
import CustomTable from "../../../components/common/CustomTable/CustomTable";
import { useReferenceDocumentStore } from "../../../hooks/useReferenceDocumentStore";
import { ModalConfirm } from "../../../components/common/ModalConfirm/ModalConfirm";

const columns = [
    { type: 'options', field: 'options', label: 'Acciones', align:'center' },
    { type: 'text', field: 'document', label: 'Tipo doc.', align:'center' },
    { type: 'text', field: 'folio', label: 'Folio', align:'center' },
    { type: 'text', field: 'description', label: 'Observación', align:'center' },
];

export const DrawerSelectCustomer:FC<any> = (props):JSX.Element|any => {

    const { getFilterProducts, setProducts, setTypeList } = props;

    const { selectCustomer, setDrawerSelectCustomer} = useDrawerStore()
    const { selectedCustomer, setSelectedCustomer, setSelectedSalesman, setPricelistName } = useSearcherStore()
    const { status: statusSupplier, supppliers, getSuppliers } = useSupplierStore()
    const { documentOfSales, getDocumentOfSales } = useDocumentOfSalesStore();
    const { getReferenceDocuments, createReferenceDocument, deleteReferenceDocument } = useReferenceDocumentStore();

    const [loading, setLoading] = useState(false);
    const [loadingSaveReference, setLoadingSaveReference] = useState(false);
    const [showModalConfirm, setShowModalConfirm] = useState<boolean>(false);
    const [salesDocumentSelected, setSalesDocumentSelected] = useState<any>('');
    const [folio, setFolio] = useState<any>('');
    const [reference, setReference] = useState<any>('');
    const [references, setReferences] = useState<any>([]);
    const [clientSelected, setClientSelected] = useState<any>('');

    useEffect(() => {
        if (selectCustomer) getInfoApis();
    },[selectCustomer])

    useEffect(() => {
        if (selectedCustomer) {
            getReferenceDocumentsApi(selectedCustomer?.id)
            getFilterProductsApi(selectedCustomer?.id);
        };
    },[selectedCustomer])

    const getInfoApis = async () => {
        await getSuppliers({ type: 1 })
    }

    const getReferenceDocumentsApi = async(idcustomer) => {
        try {
            setLoading(true);
            const response = await getReferenceDocuments({idcustomer: idcustomer});
            if(!response){
                setReferences([]);
                setLoading(false);
                return false;
            }else{
                setReferences(response || []);
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        }
    }

    const getFilterProductsApi = (idcustomer) => {
        setProducts([]);
        setTypeList('general');
        getFilterProducts && getFilterProducts({
            idcustomer: idcustomer ?? '', 
            idcategory_product: '', 
            idsubcategory_product: '',
            page: "",
            perPage: ""
        });
    }

    const onChangeCustomer = (rowSelected:any) => {
        setClientSelected(rowSelected);
        setShowModalConfirm(true);
        setPricelistName('');
    }

    const onChangeConfirm = async() => {
        if (clientSelected) {
            setSelectedCustomer(clientSelected);
            setSelectedSalesman(null);
            setShowModalConfirm(false);
            CustomSnackbar('success', 'Cliente seleccionado: ' + clientSelected.name_rz);
        }
    }

    const addReference = async() => {
        
        // const isIdAlreadyExists = dataSelected.some(item => item.id === salesDocumentSelected.id);
        // if (isIdAlreadyExists) return CustomSnackbar('error', "El tipo de documento ya fue agregado");
        // setdataSelected([...dataSelected, {id:salesDocumentSelected.id, document: salesDocumentSelected.name ,folio: folio, reference:reference}]);

        if(!salesDocumentSelected) return CustomSnackbar('error', "Seleccione un tipo de documento");
        if(!selectedCustomer) return CustomSnackbar('error', "Seleccione un cliente");
        setLoadingSaveReference(true);

        const data = {
            folio: folio,
            description:reference,
            iddocument_of_sale:salesDocumentSelected.id,
            idcustomer:selectedCustomer.id,
        }

        const response:any = await createReferenceDocument(data);
        if(response){
            getReferenceDocumentsApi(selectedCustomer?.id);
            clearInputs();
            setLoadingSaveReference(false);
        }else{
            setLoadingSaveReference(false);
            return false;
        }
    }

    const onDelete = async(rowSelected:any) => {
        if (rowSelected) {
            setLoading(true);
            const response = await deleteReferenceDocument(rowSelected.id)
            if(response){
                getReferenceDocumentsApi(selectedCustomer?.id);
                setLoading(false);
            }else{
                setLoading(false);
                return false;
            }
        }
    }

    const clearInputs = () => {
        setSalesDocumentSelected(null)
        setFolio('')
        setReference('')
    }

    return (
        <>
        <Drawer anchor="left" open={selectCustomer} onClose={() => setDrawerSelectCustomer(false)} ModalProps={{ keepMounted: true }} PaperProps={{ sx: { width: 550 }}}>
            <Grid container spacing={2} padding={4}>
                <Grid item xs={12}>
                    <Typography sx={{ color: '#000000' }}>RUT</Typography>
                    <Autocomplete
                        disablePortal
                        id="combo-box-customer"
                        value={selectedCustomer}
                        options={supppliers || []}
                        getOptionLabel={(option) => option.rut || ""}
                        isOptionEqualToValue={(option, value) => option?.id === value?.id}
                        fullWidth
                        renderInput={(params) => <TextField {...params} size="small"
                            InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                    <React.Fragment>
                                        {statusSupplier === ApiStatus.FETCHING ? <CircularProgress color="inherit" size={20} /> : null}
                                        {params.InputProps.endAdornment}
                                    </React.Fragment>
                                ),
                            }} />}
                        onChange={(e, newValue) => {
                            onChangeCustomer(newValue);
                        }}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Typography sx={{ color: '#000000' }}>Cliente</Typography>
                    <TextField
                        id="customer"
                        type="text"
                        name="customer"
                        fullWidth
                        size="small"
                        value={selectedCustomer?.name_rz || ''}
                        InputProps={{
                            readOnly: true,
                        }}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Divider sx={{ margin: '15px 0px' }}/>
                </Grid>
                <Grid item xs={12}>
                    <Typography sx={{ color: '#000000', fontWeight: 'bolder' }}>Referencias</Typography>
                </Grid>
                <Grid item xs={6}>
                    <FormLabel sx={{ color: '#000000' }}>Tipo de documento:</FormLabel>
                    <Autocomplete
                        id="type_sale"
                        size="small"
                        value={!!salesDocumentSelected ? salesDocumentSelected : null}
                        options={documentOfSales || []}
                        getOptionLabel={(option) => option?.name || ''}
                        isOptionEqualToValue={(option,value)=> option.name === value?.name} 
                        renderInput={(params) => 
                            <TextField {...params} label="" size="small"/>
                        }
                        onChange={(e, newValue: any) => {
                            setSalesDocumentSelected(newValue)
                        }}
                    />
                </Grid>
                <Grid item xs={6}>
                    <FormLabel sx={{ color: '#000000' }}>Folio documento:</FormLabel>
                    <TextField
                        id="folio"
                        type="text"
                        name="folio"
                        fullWidth
                        size="small"
                        value={folio}
                        onChange={(e)=>{setFolio(e.target.value)}}
                        variant="outlined"
                    />
                </Grid>
                <Grid item xs={12}>
                    <FormLabel sx={{ color: '#000000' }}>Razón de referencia:</FormLabel>
                    <TextField
                        id="reference"
                        type="text"
                        name="reference"
                        fullWidth
                        size="small"
                        value={reference}
                        onChange={(e)=>{setReference(e.target.value)}}
                        variant="outlined"
                    />
                </Grid>
                <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                    <Button
                        sx={{ backgroundColor: '#ffffff', border: '1px solid #69ABC3', borderRadius: '10px', color: '#69ABC3', height: '25px', padding: '6px 16px', textTransform: 'none', width: 180, "&:hover": { backgroundColor: "#ffffff" } }}
                        onClick={addReference}
                    >
                        Guardar cambios
                        {
                            loadingSaveReference && (
                                <CircularProgress color="inherit" size={12} sx={{ color: '#5b5b5b', marginLeft: "10px" }} />
                            )
                        }
                    </Button>
                </Grid>
                <Grid item xs={12}>
                    <CustomTable
                        disabled_title
                        columns={columns} 
                        loading={loading}
                        rows={references || []}
                        onRowClick={() => {}}
                        hasOptions
                        onDelete={onDelete}
                        RowsPerPage={3}
                        dense
                    />
                </Grid>
            </Grid>
        </Drawer>
        {
            showModalConfirm && (
                <ModalConfirm
                    title={"Seleccionar cliente"}
                    open={showModalConfirm}
                    closeModal={()=>{ setShowModalConfirm(false)}}
                    onConfirm={onChangeConfirm}
                    text={"¿Está seguro de realizar el cambio de cliente?. Si cuenta con productos en su carrito, los precios y descuento de estos pueden sufrir algunos cambios significativos."}
                    // status={loading}
                />
            )
        }
        </>
    )
}